import { render } from "./CourseSidebar.vue?vue&type=template&id=31e77449"
import script from "./CourseSidebar.vue?vue&type=script&lang=js"
export * from "./CourseSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__